"use strict";
// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Humla Health API
 * Humla Health API
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.TravelWillingness = void 0;
exports.instanceOfTravelWillingness = instanceOfTravelWillingness;
exports.TravelWillingnessFromJSON = TravelWillingnessFromJSON;
exports.TravelWillingnessFromJSONTyped = TravelWillingnessFromJSONTyped;
exports.TravelWillingnessToJSON = TravelWillingnessToJSON;
exports.TravelWillingnessToJSONTyped = TravelWillingnessToJSONTyped;
/**
 *
 * @export
 */
exports.TravelWillingness = {
    Willing: 'WILLING',
    WillingWithStipend: 'WILLING_WITH_STIPEND',
    NotWilling: 'NOT_WILLING'
};
function instanceOfTravelWillingness(value) {
    for (const key in exports.TravelWillingness) {
        if (Object.prototype.hasOwnProperty.call(exports.TravelWillingness, key)) {
            if (exports.TravelWillingness[key] === value) {
                return true;
            }
        }
    }
    return false;
}
function TravelWillingnessFromJSON(json) {
    return TravelWillingnessFromJSONTyped(json, false);
}
function TravelWillingnessFromJSONTyped(json, ignoreDiscriminator) {
    return json;
}
function TravelWillingnessToJSON(value) {
    return value;
}
function TravelWillingnessToJSONTyped(value, ignoreDiscriminator) {
    return value;
}
//# sourceMappingURL=TravelWillingness.js.map